import * as r from 'ramda';

export function noop() {}

export function trycatch(func) {
  try {
    return Promise.resolve(func())
  } catch (e) {
    return Promise.reject(e)
  }
}

export function delay(result, delay = 0) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      if (typeof result === 'function') {
        try {
          resolve(result());
        } catch (e) {
          reject(e)
        }
      } else {
        resolve(result)
      }
    }, delay)
  })
}

export function nextTick(result) { return delay(result, 0) }

export function attempt(tries, func, ms = 0, retry = 1) {
  return trycatch(func)
    .catch(e => {
      if (retry < tries) {
        if (ms > 0) {
          return delay(() => attempt(tries, func, ms, retry + 1), ms)
        } else {
          return attempt(tries, func, ms, retry + 1);
        }
      } else {
        throw e;
      }
    })
}

export function promise(func) {
  return new Promise((resolve, reject) => {
    try {
      func((err, result) => {
        if (err) {
          reject(err);
        } else {
          resolve(result);
        }
      })
    } catch (e) {
      reject(e)
    }
  })
}

export function resolve(target, props, targetProp) {
  if (!props) {
    props = Object.keys(target);
  }
  return Promise.all(props.map(prop => typeof target[prop] === 'function' ? target[prop]() : target[prop]))
    .then(values => {
      var ret = r.zipObj(props, values);
      if (targetProp) {
        ret[targetProp] = target;
      }
      return ret;
    })
}

export function waitFor(func, seconds = 2) {
  return new Promise((resolve, reject) => {
    const start = Date.now();
    const tryit = () => {
      if (func()) {
        resolve();
      } else if (Date.now() - start > seconds * 1000) {
        reject(new Error("Timeout waiting..."));
      } else {
        setTimeout(tryit, 10);
      }
    }
    tryit();
  })
}

export function emptyMap(...args) {
  if (args.length >= 2) {
    const [fn, arg] = args;
    if (arg === null || arg === "" || arg === undefined) return "";
    return fn(arg);
  }
  return arg => emptyMap(args[0], arg);
}

export function nullMap(...args) {
  if (args.length >= 2) {
    const [fn, arg] = args;
    if (arg === null || arg === "" || arg === undefined) return null;
    return fn(arg);
  }
  return arg => nullMap(args[0], arg);
}


// WEBPACK FOOTER //
// ./src/api/util.js